export const BOOK_NOW = 'src/components/BookNowButton/BOOK_NOW';
export const BOOK_NOW_CLICK_SEGMENT = 'src/components/BookNowButton/BOOK_NOW_CLICK_SEGMENT';

